module.exports = __webpack_public_path__ + "img/GU.66a48fb7.svg";